export class PartsMovementSaveRequest {

	requestType?: string;
	user?: User;
	warehouseUidK?: number;
	locationFrom?: LocationFrom;
	locationTO?: LocationTO;
	saldoTO?: number;
	stockType?: StockType;
    language?: string;
    typeSearch?: string;
    label?: string;
}

export class User {

	firstName?: string;
    lastName?: string;
    email?: string;
    userId?: string;
    siteCode?: number;
    country?: string;
    phone?: string;
    jobTitle?: string;
    subDivisionUidK?: number;
    bkSubDivisionC?: string;
    countryUidK?: number;
    language?: string;
    countryTimeZoneC?: number;
}

export class LocationFrom {

	whPartLocationUidK?: number;
    bkPartWhUidD?: number;
    bkWhLocationUidD?: number ;
    currentQ?: number;
    denialQ?: number;
    freeStock?: number;
    stockTypeUidD?: number;
    bkLocationC?: string;
    bkGspnPrefixC?: string;
    bkGspnBaseC?: string;
    bkGspnSuffixC?: string;
    cycleCount?: boolean;
    bkStockTypeC?: string;
    stockTypeN?: string;
    statusLocationUidD?: number;
    statusLocationR?: number;
    bkLocationTypeC?: string ;
 	partUidK?: number;
	locationN?: string;
	bkWhLocationTypeUidD?: number;
	typeSearch?: string;
	label?: string;
	updateS?: string;
}

export class LocationTO {

	whLocationUidK?: number;
    bkLocationC?: string;
    locationN?: string;
    warehouseUidK?: number;
    statusUidK?: number;
    statusR?: number;
    bkWhLocationTypeUidD?: number;
    bkLocationTypeC?: string;
}

export class StockType {
    stockTypeC?: string;
	stockType?: string;
}
